import React, { SVGProps } from 'react';

const FireIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="FireIcon">
    <path
      d="M8 15.3333C6.9981 15.3332 6.01934 15.0322 5.19061 14.4691C4.36187 13.9061 3.7214 13.1071 3.35223 12.1757C2.98306 11.2443 2.90222 10.2235 3.12019 9.24555C3.33816 8.26765 3.84489 7.37779 4.57467 6.69133C5.46933 5.84933 7.66667 4.33333 7.33334 1C11.3333 3.66667 13.3333 6.33333 9.33334 10.3333C10 10.3333 11 10.3333 12.6667 8.68667C12.8467 9.202 13 9.756 13 10.3333C13 11.6594 12.4732 12.9312 11.5355 13.8689C10.5979 14.8065 9.32608 15.3333 8 15.3333Z"
      fill="url(#paint0_linear_60_1488)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_60_1488"
        x1={8}
        y1={5.333}
        x2={8}
        y2={15.333}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FD8331" />
        <stop offset={1} stopColor="#FEC11F" />
      </linearGradient>
    </defs>
  </svg>
);

export default FireIcon;
